<h2>{{ mode }} Recent Update Entry</h2>
<div class="main-form-container">
  <div class="form-content">
    <form [formGroup]="updateEntryForm">
      <div fxLayout="column">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Title</mat-label>
          <input matInput formControlName="title" required />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Link</mat-label>
          <input matInput formControlName="link" required />
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Description</mat-label>
          <textarea
            matInput
            formControlName="description"
            rows="3"
            required
          ></textarea>
        </mat-form-field>

        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Date</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="postingDate"
            required
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
<mat-dialog-actions>
  <div class="modal-actions">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="updateEntryForm.invalid"
      (click)="onSave()"
    >
      {{ mode === 'EDIT' ? 'Update' : 'Add' }} Entry
    </button>
    <button mat-stroked-button (click)="onCancel()">Cancel</button>
    @if (mode === 'EDIT') {
      <button
        mat-stroked-button
        color="warn"
        type="button"
        (click)="onDelete()"
      >
        Delete Entry
      </button>
    }
  </div>
</mat-dialog-actions>
